import React from "react";

const CategoryContext = React.createContext<string>("");

export const CategoryContextProvider = CategoryContext.Provider;
export default CategoryContext;
